<!--
This component is an exact copy of libs/cameras/src/lib/components/camera-status/camera-status.component.html
This is a temporary solution until we can refactor the code to remove the circular dependency
and this component will be removed once we resolve this
TODO: https://taserintl.atlassian.net/browse/FD-276
-->
<ng-container [ngSwitch]="status">
  <mat-chip-list class="appliance-camera-status-chip-list">
    <mat-chip size="sm" class="downChipStats" *ngSwitchCase="CAMERA_STATUS.Down">
      <div class="downChipLabel">
        <span>{{ 'common.down' | t }}</span>
      </div>
    </mat-chip>

    <mat-chip size="sm" class="upChipStats" *ngSwitchCase="CAMERA_STATUS.Up">
      <div class="upChipLabel">
        <span>{{ 'common.up' | t }}</span>
      </div>
    </mat-chip>

    <mat-chip size="sm" class="warningChipStats" *ngSwitchCase="CAMERA_STATUS.Pending">
      <div class="pendingChipLabel">
        <span>{{ 'common.pending' | t }}</span>
      </div>
    </mat-chip>

    <mat-chip size="sm" class="unconfiguredChipStats" *ngSwitchCase="CAMERA_STATUS.Unconfigured">
      <div class="unconfiguredChipLabel">
        <span>{{ 'common.unconfigured' | t }}</span>
      </div>
    </mat-chip>

    <mat-chip size="sm" class="unmanagedChipStats" *ngSwitchCase="CAMERA_STATUS.Unmanaged">
      <div class="unmanagedChipLabel">
        <span>{{ 'common.unmanaged' | t }}</span>
      </div>
    </mat-chip>
  </mat-chip-list>
</ng-container>
